import { fetchListings } from './fetcherUtil';

export const getHousingListings = async (municipality, area, booliAreas) =>
  new Promise((resolve, reject) => {
    let query;
    if (booliAreas && booliAreas.length) {
      const ids = booliAreas.map(booliArea => booliArea.id).join(',');
      query = { areaId: ids };
    } else {
      query = { q: `${area}, ${municipality}` };
    }

    fetchListings(query).then((response) => {
      const { listings } = response.data ? response.data : [];

      listings.forEach((listing) => {
        listing.streetAddress = listing.location.address.streetAddress ? listing.location.address.streetAddress : '-';
        listing.objectType = listing.objectType ? listing.objectType : '-';
        listing.area = listing.location.namedAreas ? listing.location.namedAreas[0] : '-';
        listing.livingArea = listing.livingArea ? `${listing.livingArea} m²` : '-';
        listing.listPrice = listing.listPrice ? `${Number.parseInt(listing.listPrice, 10).toLocaleString('sv-SE')} kr` : '-';
      });

      resolve(listings);
    }).catch((err) => {
      reject(err);
    });
  });



// WEBPACK FOOTER //
// ./src/Utils/booliUtil.js